import columns from "../../../../react-table/helpers/columns";
import {
  sumTotal,
  sumTotalYesRow,
} from "../../../../react-table/helpers/rowTotals";

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    NonZeroNumberColumn,
    DateTimeColumnWithUtc,
    ExternalConsignmentLinkColumn,
  } = columns(data);

  return [
    {
      Header: "",
      columns: [
        new ExternalConsignmentLinkColumn(
          new TextColumn("Consignment ID", "consignmentId").withTotalHeader(
            "Total"
          )
        ),
        new TextColumn("Sender", "sender"),
        new TextColumn("Receiver", "receiver"),
        new TextColumn("Sending mailbox", "sendingMailbox"),
        new TextColumn("Receiving mailbox", "receivingMailbox"),
        new DateTimeColumn(
          "Consignment completion date",
          "consignmentCompletionDate"
        ),
        new DateTimeColumnWithUtc("Preparation date", "preparationDate"),
        new DateTimeColumn("On Network date (UTC)", "receptionDate"),
        new TextColumn(
          "Preparation - completion (UTC) d hh:mm",
          "preparationCompletion"
        ),
        new TextColumn(
          "On Network - consignment completion (UTC) d hh:mm",
          "receptionConsignmentCompletion"
        ),
        new TextColumn(
          "On Time (Preparation > Completion and On Network - Completion < 30 min)",
          "onTime"
        ).withTotalHeader(sumTotalYesRow),
        new NonZeroNumberColumn("Receptacles", "receptacles").withTotalHeader(
          sumTotal
        ),
        new TextColumn("LHOT Origin", "lhotOrigin"),
        new TextColumn(
          "First Leg Planned Departure",
          "firstLegPlannedDeparture"
        ),
        new TextColumn(
          "LHOT Origin - Preparation d hh:mm",
          "timeBetweenLhotOriginAndCarditPreparation"
        ),
        new TextColumn(
          "First Leg Planned Departure - Preparation d hh:mm",
          "timeBetweenCarditPreparationAndFirstPlannedDepartureTime"
        ),
      ],
    },
  ];
};
